<script lang="ts" setup>
import SkeletonSpecialityCarouselItem from '~/components/skeleton/SkeletonSpecialityCarouselItem.vue'
import { useSpecialitiesStore } from '~/store/specialities'

defineProps<{
  activeId: string|null
}>()

const emit = defineEmits<{
  (e: 'setActiveId', x: string): void
}>()

const specialitiesStore = useSpecialitiesStore()
const { getSpecialities } = storeToRefs(specialitiesStore)

specialitiesStore.fetchSpecialities()
</script>

<template>
  <div class="wrapper">
    <Carousel drag-free>
      <div class="-ml-2 flex md:-ml-4">
        <template v-if="specialitiesStore.isDataLoading">
          <SkeletonSpecialityCarouselItem
            v-for="x in 13"
            :key="x"
            class="
              ml-4 min-h-[186px] flex-[0_0_43.076923%]
              md:flex-[0_0_30.666667%] md:pl-4 lg:flex-[0_0_14.28%]
            "
          />
        </template>
        <template v-else-if="getSpecialities.length">
          <div
            v-for="x in getSpecialities"
            :key="x.id"
            class="
              flex-[0_0_43.076923%] cursor-pointer pl-2
              md:flex-[0_0_30.666667%] md:pl-4 lg:flex-[0_0_14.28%]
            "
          >
            <a
              class="
                no-select box-border flex h-full flex-col items-start justify-between rounded-3xl border border-solid
                border-transparent bg-white p-3 !no-underline
                md:items-center md:p-5
              "
              :class="x.id === activeId ? 'text-main-green font-medium !border-main-green' : 'text-main-dark'"
              href="#"
              @click.prevent="emit('setActiveId', x.id)"
            >
              <img alt="speciality icon" class="no-select h-[42px] md:h-[60px]" :src="x.attributes.iconUrl">
              <p class="no-select mt-3 text-sm leading-[1.43] tracking-normal md:text-center">{{ x.attributes.name }}</p>
            </a>
          </div>
        </template>
      </div>
    </Carousel>
  </div>
</template>
